import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "filters row" }
const _hoisted_2 = { class: "col-12 col-lg-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "svg-icon",
  focusable: "false",
  role: "img"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/frontend/dist/svg-icons/icons.svg#arrow-white" })
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "dealersSortDescending" }, "Opportunities", -1 /* HOISTED */)
const _hoisted_5 = { class: "col-12 col-lg-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Locations", -1 /* HOISTED */)
const _hoisted_7 = ["value", "innerHTML"]
const _hoisted_8 = { class: "col-12 col-lg-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Job Type", -1 /* HOISTED */)
const _hoisted_10 = ["value", "innerHTML"]
const _hoisted_11 = { class: "col-12 col-lg-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "Job Family", -1 /* HOISTED */)
const _hoisted_13 = ["value", "innerHTML"]
const _hoisted_14 = { class: "job row" }
const _hoisted_15 = { class: "col-12 col-lg-3 col-md-4" }
const _hoisted_16 = ["href", "innerHTML"]
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = {
  key: 0,
  class: "pagination pagination-sm"
}
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.sortDescending) = $event)),
          id: "dealersSortDescending",
          class: "form-check-input",
          onChange: _cache[1] || (_cache[1] = ($event: any) => ($options.updateFilters()))
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelCheckbox, _ctx.sortDescending]
        ]),
        _hoisted_3,
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLocation) = $event)),
          class: "form-control form-select",
          onChange: _cache[3] || (_cache[3] = ($event: any) => ($options.updateFilters()))
        }, [
          _hoisted_6,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
            return (_openBlock(), _createElementBlock("option", {
              value: location.name,
              innerHTML: location.name
            }, null, 8 /* PROPS */, _hoisted_7))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedLocation]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedJobType) = $event)),
          class: "form-control form-select",
          onChange: _cache[5] || (_cache[5] = ($event: any) => ($options.updateFilters()))
        }, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobtypes, (jobtype) => {
            return (_openBlock(), _createElementBlock("option", {
              value: jobtype.name,
              innerHTML: jobtype.name
            }, null, 8 /* PROPS */, _hoisted_10))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedJobType]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedJobCategory) = $event)),
          class: "form-control form-select",
          onChange: _cache[7] || (_cache[7] = ($event: any) => ($options.updateFilters()))
        }, [
          _hoisted_12,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobcategories, (jobcategory) => {
            return (_openBlock(), _createElementBlock("option", {
              value: jobcategory.name,
              innerHTML: jobcategory.name
            }, null, 8 /* PROPS */, _hoisted_13))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelSelect, _ctx.selectedJobCategory]
        ])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.paginatedJobs, (job) => {
      return (_openBlock(), _createElementBlock("div", _hoisted_14, [
        _createElementVNode("td", _hoisted_15, [
          _createElementVNode("a", {
            href: job.externalurl,
            innerHTML: job.jobposting,
            target: "_blank"
          }, null, 8 /* PROPS */, _hoisted_16)
        ]),
        _createElementVNode("td", {
          class: "col-12 col-lg-4 col-md-2 location",
          innerHTML: job.locations.join("; ")
        }, null, 8 /* PROPS */, _hoisted_17),
        _createElementVNode("td", {
          class: "col-12 col-md-2 jobtype",
          innerHTML: job.jobtypes.join("; ")
        }, null, 8 /* PROPS */, _hoisted_18),
        _createElementVNode("td", {
          class: "col-12 col-lg-3 col-md-4",
          innerHTML: job.jobcategories.join("; ")
        }, null, 8 /* PROPS */, _hoisted_19)
      ]))
    }), 256 /* UNKEYED_FRAGMENT */)),
    _createElementVNode("div", null, [
      ($options.orderedJobs.length > $options.paginatedJobs.length)
        ? (_openBlock(), _createElementBlock("ul", _hoisted_20, [
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", [{ 'disabled': _ctx.pageNumber === 1 }]])
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "page-link",
                onClick: _cache[8] || (_cache[8] = ($event: any) => ($options.setPage(1)))
              }, "«")
            ], 2 /* CLASS */),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseInt($options.pageCount), (index) => {
              return (_openBlock(), _createElementBlock("li", {
                class: _normalizeClass(["page-item", [{ 'active': index === _ctx.pageNumber }]]),
                key: index
              }, [
                _createElementVNode("a", {
                  href: "#",
                  class: "page-link",
                  onClick: ($event: any) => ($options.setPage(index))
                }, _toDisplayString(index), 9 /* TEXT, PROPS */, _hoisted_21)
              ], 2 /* CLASS */))
            }), 128 /* KEYED_FRAGMENT */)),
            _createElementVNode("li", {
              class: _normalizeClass(["page-item", [{ 'disabled': _ctx.pageNumber === $options.pageCount }]])
            }, [
              _createElementVNode("a", {
                href: "#",
                class: "page-link",
                onClick: _cache[9] || (_cache[9] = ($event: any) => ($options.setPage($options.pageCount)))
              }, "»")
            ], 2 /* CLASS */)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}